import { ContentBlock, Card, Stack, Text, Heading } from 'braid-design-system';
import React from 'react';

const Error = () => (
  <ContentBlock>
    <Card>
      <Stack space="medium">
        <Heading level="2"> Something went wrong </Heading>
        <Text>
          Sorry, something went wrong processing your request. Call customer
          service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) to arrange
          reactivation of your ad
        </Text>
      </Stack>
    </Card>
  </ContentBlock>
);

export default Error;
